import { gql } from '@apollo/client';
import { DocumentNode } from 'graphql';

export const SHARE_REFERRAL: DocumentNode = gql`
  mutation ShareReferral($friendEmails: [String]) {
    shareReferral(friendEmails: $friendEmails) {
      token
    }
  }
`;

export const GET_VOUCHERS: DocumentNode = gql`
  query GetVouchers {
    getAdvocateDiscounts {
      discounts {
        code
        usedDate
        creationDate
        redeem {
          email
          friendName
        }
        amount
        referral {
          campaign {
            advocateFreeTrialStartsDiscountValue
            advocateSubscriptionStartsDiscountValue
          }
        }
      }
      totalAvailableDiscount
      totalAwaitingDiscount
    }
  }
`;
